import type { Answer } from 'types/answers'
import { quotePreviewForAnswer, quoteSnippetFromPreview } from './quotePreview'

// The flat one-string form of a quote preview, for surfaces that render text
// only. The rules live in quotePreview.ts so the string and the chip-rendering
// quote line can never disagree about what a post is.
//
// `answerModel` was the old text-extraction dependency; the preview resolves
// text through the shared display projection now, so the parameter is ignored
// and kept only for call sites that still pass it.
export function quoteSnippetForAnswer(
    answer: Partial<Answer> | null | undefined,
    _answerModel?: unknown,
): string {
    return quoteSnippetFromPreview(quotePreviewForAnswer(answer))
}
